export default __webpack_public_path__ + "static/media/shopping_cart_blue.656933ae.svg";